import axios from "axios";

// export const BASE_URL =
//    process.env.NODE_ENV === "development"
//       ? "http://localhost:8000/api"
//       : "https://webideasolution.in/eisakutms/public/api";

export const BASE_URL = "https://developement.v1.eisakutms.com/api";


const request = (methodName, endPoint, data, authorization = false) => {
   let headers = {};
   if (authorization) {
      headers = {
         Authorization: `Bearer ${JSON.parse(localStorage.getItem("token"))}`,
      };
   }

   return axios({
      method: methodName,
      url: BASE_URL + endPoint,
      headers,
      data,
      // timeout: 60000, // 15 seconds timeout
      // timeoutErrorMessage: "Request timed out. Please try again.",
   });
};

export const getService = (endPoint, authorization) =>
   request("GET", endPoint, null, authorization);

export const postService = (endPoint, data, authorization) =>
   request("POST", endPoint, data, authorization);

export const putService = (endPoint, data, authorization) =>
   request("PUT", endPoint, data, authorization);

export const patchService = (endPoint, data, authorization) =>
   request("PATCH", endPoint, data, authorization);

export const deleteService = (endPoint, authorization) =>
   request("DELETE", endPoint, null, authorization);
